// extracted by mini-css-extract-plugin
export default {"registerForFinalButton":"RegisterForFinal_registerForFinalButton__Zjm-l","registerForFinalButtonText":"RegisterForFinal_registerForFinalButtonText__d7wxP"};